export default "__VITE_ASSET__79f1d41a__"